import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, throwError } from 'rxjs';
import {
  ConfirmModalComponent,
  ConfirmModalConfig,
} from 'src/app/modules/shared/modals/confirm-modal/confirm.modal.component';
import { ModalButton } from 'src/app/modules/shared/modals/modal.button';
import { ModalResult } from 'src/app/modules/shared/modals/modal.result';
import { ModalService } from 'src/app/modules/shared/modals/modal.service';
import { ErrorResponse } from 'src/app/modules/shared/viewmodels/error.response';

export const conflictHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const modalService = inject(ModalService);

  return next(req).pipe(
    catchError((res: HttpErrorResponse) => {
      if (res.status === 409) {
        if (res.error instanceof Blob) {
          // Handle Blob errors
          return from(
            new Promise<string>((resolve) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result as string);
              reader.readAsText(res.error);
            }).then((text) => {
              showConflictModal(text, modalService);
              throw res;
            })
          );
        } else if (typeof res.error === 'object') {
          // Handle JSON errors
          const error: Partial<ErrorResponse> = res.error;
          const errorMessage = error?.message ?? JSON.stringify(res.error);
          showConflictModal(errorMessage, modalService);
        } else {
          // Handle String errors
          const errorMessage = res.error || res.statusText || 'Conflict error occurred';
          showConflictModal(errorMessage, modalService);
        }
      }
      return throwError(() => res);
    })
  );
};

function showConflictModal(errorMessage: string, modalService: ModalService) {
  const confirmModal = modalService.createInstance(ConfirmModalComponent, {
    title: 'Conflict Error',
    size: 'sm',
    message: errorMessage,
    secondaryButton: null,
    primaryButton: new ModalButton('Refresh', 'btn-danger', ModalResult.primary, 'Refreshing'),
  } as ConfirmModalConfig);

  confirmModal.result.subscribe((r) => {
    if (r === ModalResult.primary) {
      window.location.reload();
    } else {
      confirmModal.hide();
    }
  });
}
